var path = '/vendor/boomerang-master/boomerang-reload.html';
var html = "<!doctype html> <html> <head> <script src=boomerang.js></script> <script>var v=decodeURIComponent(location.search.replace(/.*v=([0-9.]+).*/,\"$1\"));window.onload=function(){var o=BOOMR.version.split(\".\"),n=v.split(\".\");(o[0]<n[0]||o[0]==n[0]&&o[1]<n[1]||o[0]==n[0]&&o[1]==n[1]&&o[2]<n[2])&&location.reload(!0)}</script> </head> <body> </body> </html> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/vendor/boomerang-master/boomerang-reload.html
// module id = 808
// module chunks = 0 2